import { useEffect, useRef } from "react";

/**
 * Automatically focuses an element as soon as it mounts.
 *
 * @example
 * const inputRef = useAutoFocus<HTMLInputElement>();
 * <input ref={inputRef} />
 */
function useAutoFocusInput<T extends HTMLElement>(
  shouldFocus: boolean = false
) {
  const elementRef = useRef<T | null>(null);

  useEffect(() => {
    // Avoid running in non-browser environments (like SSR)
    if (shouldFocus && typeof window !== "undefined") {
      setTimeout(() => elementRef.current?.focus(), 0);
    }
  }, [shouldFocus]);

  return { elementRef };
}

export default useAutoFocusInput;
